export enum KnmRegistryTypeEnum {
  EGRUL = 'ЕГРЮЛ',
  EGRIP = 'ЕГРИП',
  MSP = 'МСП',
  TOSER = 'ТОСЭР',
  SPV = 'СПВ',
  OEZ = 'ОЭЗ',
}
